var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "-50 -20 180 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 180,
    height: 120,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_3607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0005 31.0903H19V17.9111C19 15.2031 21.2031 13 23.9111 13H42.0893C44.7974 13 47.0005 15.2031 47.0005 17.9111L47.0005 31.0903ZM22 28.0903H44.0005V17.9111C44.0005 16.8574 43.1431 16 42.0894 16H23.9111C22.8574 16 22 16.8574 22 17.9111V28.0903Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0894 67.3433H23.9111C21.2031 67.3433 19 65.1401 19 62.4321V28.1167H47.0005V62.4321C47.0005 65.1401 44.7974 67.3433 42.0894 67.3433ZM22 31.1167V62.4321C22 63.4858 22.8574 64.3433 23.9111 64.3433H42.0893C43.1431 64.3433 44.0005 63.4858 44.0005 62.4321V31.1167H22Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2843 35.6099H38.0836C36.2058 35.6099 34.6836 37.1321 34.6836 39.0099V62.4433C34.6836 64.3211 36.2058 65.8433 38.0836 65.8433H56.2843C58.1621 65.8433 59.6843 64.3211 59.6843 62.4433V39.0099C59.6843 37.1321 58.1621 35.6099 56.2843 35.6099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2847 67.3433H38.084C35.3818 67.3433 33.1836 65.145 33.1836 62.4434V39.0098C33.1836 36.3081 35.3818 34.1099 38.084 34.1099H56.2847C58.9863 34.1099 61.1846 36.3081 61.1846 39.0098V62.4434C61.1846 65.145 58.9863 67.3433 56.2847 67.3433ZM38.084 37.1099C37.0361 37.1099 36.1836 37.9619 36.1836 39.0098V62.4433C36.1836 63.4912 37.0361 64.3432 38.084 64.3432H56.2847C57.3325 64.3432 58.1846 63.4912 58.1846 62.4433V39.0098C58.1846 37.9619 57.3325 37.1099 56.2847 37.1099H38.084Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6182 26.063C24.7896 26.063 24.1182 25.3916 24.1182 24.563V19.9116C24.1182 19.083 24.7896 18.4116 25.6182 18.4116C26.4468 18.4116 27.1182 19.083 27.1182 19.9116V24.563C27.1182 25.3916 26.4468 26.063 25.6182 26.063Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6182 41.1797C24.7896 41.1797 24.1182 40.5083 24.1182 39.6797V35.0283C24.1182 34.1997 24.7896 33.5283 25.6182 33.5283C26.4468 33.5283 27.1182 34.1997 27.1182 35.0283V39.6797C27.1182 40.5083 26.4468 41.1797 25.6182 41.1797Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4751 62.6919C42.8008 62.6919 38.998 58.8892 38.998 54.2148C38.998 49.541 42.8008 45.7383 47.4751 45.7383C52.1489 45.7383 55.9517 49.541 55.9517 54.2148C55.9517 58.8892 52.1489 62.6919 47.4751 62.6919ZM47.4751 48.7383C44.4551 48.7383 41.998 51.1948 41.998 54.2148C41.998 57.2349 44.4551 59.6919 47.4751 59.6919C50.4951 59.6919 52.9517 57.2349 52.9517 54.2148C52.9517 51.1948 50.4951 48.7383 47.4751 48.7383Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.103 41.0869H34.6836V44.0869H59.103V41.0869Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6382 40.0981H46.3125C45.7602 40.0981 45.3125 39.6504 45.3125 39.0981C45.3125 38.5459 45.7602 38.0981 46.3125 38.0981H48.6382C49.1904 38.0981 49.6382 38.5459 49.6382 39.0981C49.6382 39.6504 49.1904 40.0981 48.6382 40.0981Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4517 40.0981H52.126C51.5737 40.0981 51.126 39.6504 51.126 39.0981C51.126 38.5459 51.5737 38.0981 52.126 38.0981H54.4517C55.0039 38.0981 55.4517 38.5459 55.4517 39.0981C55.4517 39.6504 55.0039 40.0981 54.4517 40.0981Z",
    fill: "#A38800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 35.6099H40.1602V42.396H43.1602V35.6099Z",
    fill: "#A38800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_3607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1846,
    height: 54.3433,
    fill: "white",
    transform: "translate(19 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXly);
export default __webpack_public_path__ + "static/media/XLY.25120238a15db9a6c3a832d794c4c2b5.svg";
export { ForwardRef as ReactComponent };